/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

function Navbar() {
  return (
    <header id="header" className="header">
      <div className="header-nav">
        <div className="header-nav-wrapper navbar-scrolltofixed bg-white">
          <div className="container">
            <nav id="menuzord-right" className="menuzord default">
              <a className="menuzord-brand pull-left flip" href="/">
                <img src="images/MRCS.svg" alt="МУЗН лого"/>
              </a>
              <ul className="menuzord-menu">
                <li className="active">
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/emergencies">Emergencies</a>
                </li>
                <li>
                  <a href="/appeals">Appeals</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
